import { RouterProvider } from 'react-router-dom';
import { ConsentBanner, useAnalyticsConsent } from '@/features/consent';
import { InstallBanner, useInstallPrompt } from '@/features/pwa';
import { AppProviders } from '@/providers';
import { router } from '@/router';

function AppContent() {
  const { consentStatus, acceptConsent, declineConsent } = useAnalyticsConsent();
  const { showBanner: showInstall, install, dismiss: dismissInstall } = useInstallPrompt();

  return (
    <>
      <RouterProvider router={router} />
      {consentStatus === 'pending' && (
        <ConsentBanner onAccept={acceptConsent} onDecline={declineConsent} />
      )}
      {consentStatus !== 'pending' && showInstall && (
        <InstallBanner onInstall={install} onDismiss={dismissInstall} />
      )}
    </>
  );
}

function App() {
  return (
    <AppProviders>
      <AppContent />
    </AppProviders>
  );
}

export default App;
